
// Custom JS for specific Shopify page behaviors
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const $ = window.jQuery;

    if (typeof $ === 'undefined') return;

    // Only run on product pages
    const isProductPage = window.location.pathname.includes('/products/');
    const isAccountPage = window.location.pathname.includes('/account');

    if (isProductPage) {
      $(".product__accordion").wrapAll("<div class='new' />");

      $('#shopify-block-subscriptions_app_block_RMaQjF').addClass('wapperSection');
      $('#rbz-zipcode-check-section').addClass('wapperSection');
      $(".wapperSection").wrapAll("<div class='commonSection' />");

      $('.product-customproduct .onlycostomproduct').addClass('wapperSection01');
      $('.product-customproduct .new').addClass('wapperSection01');
      $(".wapperSection01").wrapAll("<div class='commonSectionLatest' />");
      $(".commonSection").wrapAll("<div class='commonSectionMain' />");

      $(".product-customproduct .commonSectionMain").prepend(
        "<div class='subscribeOption'><div class='iconOptions'>▼</div><span>Subscribe Options</span></div>"
      );

      $(document).on('click', '.product-customproduct .subscribeOption', function() {
        // Toggle logic if needed
      });
    }

    // Add subscription user class to body
    if ($('.appstle_manageSubBtn').length > 0) {
      $('body').addClass('papa');
    }

    if ($('.subscriptionUser').length > 0) {
      $('body').addClass('siteuser');
    }

    // Only run ZIP code logic if elements exist
    if (document.querySelector('.zipcode_checkout_btn_info')) {
      setInterval(() => {
        const els = document.querySelectorAll('.zipcode_checkout_btn_info');
        const body = document.body;

        if (els.length > 1) {
          body.classList.add('onlyPostcode');
          body.classList.remove('allPostcode');
        } else {
          body.classList.add('allPostcode');
          body.classList.remove('onlyPostcode');
        }

        const zip = document.getElementById('check_zipcode')?.textContent;
        if (zip === '0') {
          body.classList.add('zip-code');
        } else {
          body.classList.remove('zip-code');
        }
      }, 1000);
    }

    // Time and billing info - only on account page
    if (isAccountPage) {
      function startTime() {
        const elements = document.querySelectorAll('.as-tab-content-wrapper .as-edit-billing_info h3.as-text-sm');
        const date = new Date();
        elements.forEach(el => {
          el.innerHTML = date.toLocaleTimeString();
        });

        setTimeout(startTime, 1000);
      }

      startTime();

      function checkDates() {
        const mainElements = document.getElementsByClassName("as-edit-billing_data");
        Array.from(mainElements).forEach(el => {
          console.log(el.innerText);
        });
      }

      setTimeout(checkDates, 1500);
    }
  });
})();
